import { motion } from "framer-motion";
import { HOW_IT_WORKS_STEPS } from "@/constants/business";

export default function HowItWorksSection() {
  return (
    <section data-testid="how-it-works-section" className="py-14 md:py-20 px-4 md:px-8 max-w-7xl mx-auto">
      <div className="mb-10 max-w-2xl">
        <span className="text-xs uppercase tracking-[0.2em] font-bold text-orange">Le déroulement</span>
        <h2 className="font-heading font-bold text-3xl md:text-4xl tracking-tight text-navy mt-3">
          Comment se déroule votre transport ?
        </h2>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-6">
        {HOW_IT_WORKS_STEPS.map((step, i) => (
          <motion.div
            key={step.title}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.3, delay: i * 0.05 }}
            data-testid={`how-it-works-step-${i}`}
            className="flex gap-4 border-t-2 border-gray-200 pt-4"
          >
            <span className="font-heading font-extrabold text-2xl text-orange leading-none shrink-0">
              {i + 1}
            </span>
            <div>
              <h3 className="font-heading font-semibold text-base text-navy mb-1">{step.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{step.text}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
